module.exports = __webpack_public_path__ + "static/media/logo.b12c3239.png";